import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import DataTable from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsAttributesStyles {
    wrapper?: InjectableCss;
    attributeTypeLabelText?: TypographyPresentationProps;
    attributeTypeValuesText?: TypographyPresentationProps;
    specificationTittle?: InjectableCss;
    specificationContainer?: InjectableCss;
    tablediv?: InjectableCss;
    specDataTableCellCss?: InjectableCss;
    specAttrdataTableCellCss?: InjectableCss;
    dataRowCss?: InjectableCss;
    descriptionAccordion?: InjectableCss;
    mainAccordion?: InjectableCss;
    tableContainer?: InjectableCss;
    firstTableDiv?: InjectableCss;
    tableBody?: InjectableCss;
    specificationLable?: InjectableCss;
    attributeValues?: InjectableCss;
}

export const attributesStyles: ProductDetailsAttributesStyles = {
    wrapper: {
        css: css`
            padding-bottom: 15px;
        `,
    },
    attributeTypeLabelText: {
        weight: "bold",
    },
    attributeTypeValuesText: {
        css: css`
            margin-bottom: 5px;
        `,
    },
    specificationTittle: {
        css: css`
            border-bottom: 0.2rem solid #fc3;
            box-sizing: border-box;
            display: inline-flex;
            font-weight: 600;
            color: #474747;
            font-size: 24px;
            text-transform: uppercase;
        `,
    },
    specificationContainer: {
        css: css``,
    },

    tablediv: {
        css: css`
            border-collapse: collapse;
            border-spacing: 0;
            width: 100%;
        `,
    },
    specDataTableCellCss: {
        css: css`
            white-space: normal;
            max-width: 300px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0;
                    `,
                    css`
                        padding: 0;
                    `,
                    css`
                        height: 0;
                    `,
                    css`
                        height: 0;
                    `,
                    null,
                ])}
        `,
    },
    specAttrdataTableCellCss: {
        css: css`
            padding: 0 16px;
            white-space: normal;
            box-sizing: content-box;
            background: #ccc;
            max-width: 300px;
            width: 50%;
            height: 20px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 50%;
                    `,
                    css`
                        width: 50%;
                    `,
                    css`
                        width: 50%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    dataRowCss: {
        css: css`
            width: 50%;
            height: auto;
            display: flex;
            border: 1px solid #acacac;
            /* height: 36px; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])}
            :nth-child(even) {
                background-color: white !important;
            }
        `,
    },
    descriptionAccordion: {
        css: css`
            margin-bottom: 20px;
            border-top: 1px solid #ccc;
        `,
    },
    mainAccordion: {
        css: css`
            dt button {
                background-color: #262a35 !important;
                span {
                    color: #fff;
                    font-size: 1.3rem;
                    font-weight: normal;
                }
            }
        `,
    },
    tableContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            margin-left: 0;
            margin-right: 0;
        `,
    },
    firstTableDiv: {
        css: css`
            flex: 0 0 100%;
            max-width: 100%;
        `,
    },
    tableBody: {
        css: css`
            border: 0 solid;
            border-color: inherit;
            display: flex;
            flex-wrap: wrap;
        `,
    },
    specificationLable: {
        css: css`
            width: 50%;
            padding: 5px;
            background: #ccc;
            font-weight: 700;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        `,
    },
    attributeValues: {
        css: css`
            width: 50%;
            color: #000;
            padding: 0px 10px;
            white-space: normal;
        `,
    },
};

const styles = attributesStyles;

const ProductDetailsAttributes: React.FC<Props> = ({ product: { brand, attributeTypes } }) => {
    if (!brand && (!attributeTypes || attributeTypes.length === 0)) {
        return null;
    }

    const limitedAttributeTypes = attributeTypes?.filter(attributeType => attributeType.includeOnProduct) ?? [];

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="productDetails_attributes">
            {brand && (
                <Typography data-test-selector="brand_item" as="p" {...styles.attributeTypeValuesText}>
                    <Typography data-test-selector="brand_item_label" {...styles.attributeTypeLabelText}>
                        {translate("Brand")}&nbsp;:&nbsp;
                    </Typography>
                    <span data-test-selector="brand_item_value">{brand.name}</span>
                </Typography>
            )}
            {/* {limitedAttributeTypes.map(attributeType => (
                <Typography
                    key={attributeType.id.toString()}
                    data-test-selector="attributes_item"
                    data-attributetypeid={attributeType.id}
                    {...styles.attributeTypeValuesText}
                    as="p"
                >
                    <Typography data-test-selector="attributes_item_label" {...styles.attributeTypeLabelText}>
                        {attributeType.label || attributeType.name}&nbsp;:&nbsp;
                    </Typography>
                    <span data-test-selector="attributes_item_value">
                        {(attributeType.attributeValues ?? [])
                            .map(attributeValue => attributeValue.valueDisplay)
                            .join(", ")}
                    </span>
                </Typography>
            ))} */}

            <StyledWrapper {...styles.descriptionAccordion}>
                <StyledWrapper>
                    <Typography {...styles.specificationTittle}>SPECIFICATIONS</Typography>
                </StyledWrapper>
                <StyledWrapper {...styles.tableContainer}>
                    <StyledWrapper {...styles.firstTableDiv}>
                        <DataTable {...styles.tablediv}>
                            <DataTableBody {...styles.tableBody}>
                                {limitedAttributeTypes?.map(
                                    (
                                        specification: {
                                            name: string | number | undefined;
                                            label: any;
                                            attributeValues: any;
                                        },
                                        index: number,
                                    ) => (
                                        <DataTableRow {...styles.dataRowCss} key={index}>
                                            <Typography {...styles.specificationLable}>
                                                {specification.label}
                                            </Typography>
                                            <Typography {...styles.attributeValues}>
                                                {specification.attributeValues
                                                    ?.map(
                                                        (attributeValue: { valueDisplay: any }) =>
                                                            attributeValue.valueDisplay,
                                                    )
                                                    .join(", ")}
                                            </Typography>
                                        </DataTableRow>
                                    ),
                                )}
                            </DataTableBody>
                        </DataTable>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsAttributes),
    definition: {
        displayName: "Attributes",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
